import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLFormElement> {
  static targets = ['description', 'submit']

  declare readonly descriptionTarget: HTMLTextAreaElement
  declare readonly submitTarget: HTMLInputElement
  declare readonly hasSubmitTarget: boolean

  connect(): void {
    this.toggle()
  }

  toggle(): void {
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = !this.hasDescription()
      this.submitTarget.ariaDisabled = String(!this.hasDescription())
    }
  }

  start(event: CustomEvent): void {
    if (event.detail.formSubmission.submitter !== this.submitTarget) return
    this.element.setAttribute('inert', '')
  }

  end(event: CustomEvent): void {
    if (event.detail.formSubmission.submitter !== this.submitTarget) return
    if (!event.detail.success) this.element.removeAttribute('inert')
  }

  private hasDescription(): boolean {
    return this.descriptionTarget.value.trim().length > 0
  }
}
